import { motion } from "framer-motion";
import {
  Globe, RefreshCw, Search, FileText, CalendarClock, Wrench,
  Workflow, Bot, Mic, TrendingUp, ArrowUpRight, MapPin, QrCode,
} from "lucide-react";

const services = [
  { icon: Globe, title: "Sites web professionnels", desc: "Un site clair, rapide et pensé pour transformer vos visiteurs en clients." },
  { icon: RefreshCw, title: "Refonte de sites", desc: "Votre site existant remis au goût du jour : plus moderne, plus rapide, plus visible." },
  { icon: Search, title: "Être trouvé sur Google", desc: "Positionnement Marssac, Albi, Gaillac, Castres, Carmaux — que vos clients vous trouvent." },
  { icon: MapPin, title: "Fiche Google (Maps)", desc: "Votre page sur Google Maps optimisée pour capter les clients à proximité." },
  { icon: QrCode, title: "QR Code professionnel", desc: "Page dédiée + QR à afficher en boutique, cartes, véhicules." },
  { icon: FileText, title: "Formulaires intelligents", desc: "Formulaires clairs qui qualifient vos prospects et vous font gagner du temps." },
  { icon: CalendarClock, title: "Prise de rendez-vous", desc: "Réservation en ligne avec confirmation automatique." },
  { icon: Wrench, title: "Maintenance", desc: "Mises à jour, sauvegardes, support — 30 €/mois." },
  { icon: Workflow, title: "Automatisations", desc: "CRM, email, agenda connectés. Des heures gagnées." },
  { icon: Bot, title: "Chatbots IA", desc: "Assistants qui répondent à vos visiteurs 24/7." },
  { icon: Mic, title: "Agents vocaux IA", desc: "Standard téléphonique IA : qualification et prise de RDV." },
  { icon: TrendingUp, title: "Plus de contacts reçus", desc: "On analyse et améliore votre site pour recevoir plus de demandes." },
];

export const Solutions = () => (
  <section id="services" data-testid="solutions-section" className="py-24 md:py-32 bg-gradient-to-br from-ink via-ink to-ink-700 text-white relative overflow-hidden">
    <div className="absolute inset-0 grain opacity-[0.5]" aria-hidden />
    <div className="absolute top-0 right-0 w-[700px] h-[700px] bg-cyan/20 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3" aria-hidden />
    <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-20">
        <div className="lg:col-span-7">
          <p className="font-mono-label text-white/55"><span className="rule" />Solutions</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Une présence digitale conçue pour{" "}
            <em className="italic font-light">générer des résultats</em>.
          </h2>
        </div>
        <div className="lg:col-span-4 lg:col-start-9 text-white/65 leading-relaxed">
          Des services complémentaires pour transformer votre site en outil
          commercial.
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {services.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.article
              key={s.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
              className="bg-ink p-8 md:p-10 group hover:bg-ink-600 transition-colors min-h-[230px] flex flex-col justify-between"
              data-testid={`service-${i}`}
            >
              <div className="flex items-start justify-between">
                <Icon size={22} className="text-white/80 group-hover:-translate-y-0.5 transition-transform" />
                <span className="font-mono-label text-white/35">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <div className="mt-8">
                <h3 className="font-display text-2xl">{s.title}</h3>
                <p className="mt-3 text-sm text-white/65 leading-relaxed">{s.desc}</p>
              </div>
            </motion.article>
          );
        })}
        <a
          href="#contact"
          data-testid="services-cta"
          className="bg-white text-ink p-8 md:p-10 min-h-[230px] flex flex-col justify-between group hover:bg-paper-soft transition-colors"
        >
          <span className="font-mono-label">Échangeons</span>
          <div>
            <h3 className="font-display text-2xl">Discutons de votre projet</h3>
            <p className="mt-3 text-sm text-ink/70">Réponse personnalisée sous 24h.</p>
            <ArrowUpRight size={20} className="mt-6 text-ink group-hover:-translate-y-0.5 transition-transform" />
          </div>
        </a>
      </div>
    </div>
  </section>
);
